import { render, staticRenderFns } from "./DefaultSection.vue?vue&type=template&id=1cde9918&"
import script from "./DefaultSection.vue?vue&type=script&lang=js&"
export * from "./DefaultSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports